
import { useLocation } from 'react-router-dom'

const ShowNavBar = ({ children }: { children: React.ReactNode }) => {

    const location = useLocation();

    if(location.pathname==='/login'||location.pathname==='/forgot-password'){
        return null
    }

  return (
    <div>
        {children}
    </div>
  )
}

export default ShowNavBar